// https://vuex.vuejs.org/en/actions.html
export const recalculaNutrientes = ({ state }, index) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      for (let nutriente in state.app.alimentos_selecionados[index].nutrientes) {
        state.app.alimentos_selecionados[index].nutrientes[nutriente] = state.app.alimentos_selecionados[index].nutrientes_originais[nutriente]
      }
      state.app.alimentos_selecionados[index].alterado = false
      resolve()
    }, 1000)
  })
}
